import { render, staticRenderFns } from "./AvatarWrapper.vue?vue&type=template&id=4b376a3d&scoped=true&"
import script from "./AvatarWrapper.vue?vue&type=script&lang=js&"
export * from "./AvatarWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AvatarWrapper.vue?vue&type=style&index=0&id=4b376a3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b376a3d",
  null
  
)

export default component.exports